import { AutoComplete, Entidade } from '@elotech/components';
import { AxiosPromise } from 'axios';
import React, { FC } from 'react';

export type EntidadeSearchProps = {
  name: string;
  size: number;
  onSelect: (name: string, value) => void;
  onSearch(search: string): AxiosPromise<any>;
  label?: string;
  value: any;
  error?: any;
  disabled?: boolean;
  disableFormGroup?: boolean;
};

const EntidadeSearch: FC<EntidadeSearchProps> = ({
  name,
  onSelect,
  onSearch,
  label = 'Entidade',
  value,
  error,
  size,
  disabled = false,
  disableFormGroup = false,
  ...props
}) => {
  return (
    <div className={`col-md-${size}`}>
      <div className={`${disableFormGroup ? '' : 'form-group'}`}>
        <label className="label" htmlFor={name}>
          {label}
        </label>
        <AutoComplete
          isDisabled={disabled}
          value={value}
          getOptionLabel={(entidade: Entidade) =>
            `${entidade.id} - ${entidade.nome}`
          }
          getOptionValue={(entidade: Entidade) => entidade.id}
          autoFocus={false}
          name={name}
          onSearch={onSearch}
          onSelect={(name, value): void => {
            onSelect(name, value);
          }}
          className={error ? 'error' : ''}
          {...props}
        />
        {error && <span className="help-message">{error}</span>}
      </div>
    </div>
  );
};

export { EntidadeSearch };
